import api from '../api';

const FinanceService = {
  listAccounts() {
    return api.get('/finance/accounts');
  },
  createAccount(payload) {
    return api.post('/finance/accounts', payload);
  },
  updateAccount(id, payload) {
    return api.put(`/finance/accounts/${id}`, payload);
  },
  deleteAccount(id) {
    return api.delete(`/finance/accounts/${id}`);
  },
  listTransactions(accountId, params = {}) {
    return api.get(`/finance/accounts/${accountId}/transactions`, { params });
  },
  createManualTransaction(accountId, payload) {
    return api.post(`/finance/accounts/${accountId}/transactions`, payload);
  },
  updateTransaction(accountId, transactionId, payload) {
    return api.patch(`/finance/accounts/${accountId}/transactions/${transactionId}`, payload);
  },
  deleteTransaction(accountId, transactionId) {
    return api.delete(`/finance/accounts/${accountId}/transactions/${transactionId}`);
  },
  listCategories() {
    return api.get('/finance/categories');
  },
  createCategory(payload) {
    return api.post('/finance/categories', payload);
  },
  updateCategory(id, payload) {
    return api.put(`/finance/categories/${id}`, payload);
  },
  deleteCategory(id) {
    return api.delete(`/finance/categories/${id}`);
  },
  createSubcategory(categoryId, payload) {
    return api.post(`/finance/categories/${categoryId}/subcategories`, payload);
  },
  updateSubcategory(id, payload) {
    return api.put(`/finance/subcategories/${id}`, payload);
  },
  deleteSubcategory(id) {
    return api.delete(`/finance/subcategories/${id}`);
  },
  importOfx(accountId, file) {
    const formData = new FormData();
    formData.append('file', file);
    return api.post(`/finance/accounts/${accountId}/import-ofx`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  syncAccount(accountId) {
    return api.post(`/finance/accounts/${accountId}/sync`);
  },
  reconcile(accountId, payload) {
    return api.post(`/finance/accounts/${accountId}/reconcile`, payload);
  },
  downloadReport(accountId, params = {}) {
    return api.get(`/finance/accounts/${accountId}/report`, {
      params,
      responseType: 'blob',
    });
  },
  getCategorySummary(accountId, params = {}) {
    return api.get(`/finance/accounts/${accountId}/categories-report`, { params });
  },
};

export default FinanceService;
